export default "__VITE_ASSET__5a593bc4__"